import React from "react";
import ReactDom from "react-dom";
import { getEstados } from "../requests/req_general";
import {
  Col,
  Button,
  FormGroup,
  ListGroup,
  ListGroupItem,
  Form,
  Row,
} from "reactstrap";
import Select from "react-select";
import { ButtonContainer, InputsContainer, MainContainer, Container } from "./styles/CajaBusqueda/styled.components";

export default class CajaBusqueda extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      isSearchable: true,
      estados: [],
      options: [],
      estado: {},
    };
    this.goEstado = this.goEstado.bind(this);
    this.goOfertas = this.goOfertas.bind(this);
    this.buscaEstado = this.buscaEstado.bind(this);
    this.generaEstados = this.generaEstados.bind(this);
    this.estableceEstados = this.estableceEstados.bind(this);
    this.onChangeFunc = this.onChangeFunc.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    // let url = localStorage.getItem('url');
    getEstados((e) => this.estableceEstados(e));
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  estableceEstados(datos) {
    if (this._isMounted) {
      const options = datos.map((op, index) => {
        return { value: op.idEstado, label: op.estado };
      });
      this.setState({ estados: datos, options });
    }
  }

  goOfertas(e) {
    let lbl = document.getElementById("lbl_util"),
      inpPst = document.getElementById("inpPuesto"),
      pst = '"idPuesto":"' + inpPst.value + '"',
      inpEst = this.state.estado.Name;
    //inpEst = document.getElementById('inpEstado');

    let idEst = this.state.estado.id;
    //inpEst=inpEst.options[inpEst.selectedIndex].innerText

    idEst = typeof idEst === "undefined" ? null : idEst;
    inpEst = typeof inpEst === "undefined" ? "" : inpEst;

    if (idEst !== null) {
      var std = inpEst !== "" ? ',"idEstado":"' + idEst + '"' : "";
      lbl.innerText = pst + std;
    } else {
      if (inpEst !== "") {
        var lst = this.state.estados.filter((f) => f.nombre.includes(inpEst));
        lbl.innerText = pst + ',"idEstado":"' + lst[0].abbr + '"';
      } else {
        lbl.innerText = pst;
      }
    }
    document.getElementById("Id_ofertas").click();
  }

  buscaEstado(e) {
    var elm = e.target,
      vl = elm.value,
      dv = document.getElementById("match_list");
    ReactDom.unmountComponentAtNode(dv);
    if (vl !== "") {
      ReactDom.render(
        <ListGroup onClick={(e) => this.goEstado(e)} className="lst_bsqueda">
          {this.generaEstados(vl)}
        </ListGroup>,
        dv
      );
    }
  }

  generaEstados(valor) {
    if (this.state.estados !== null && this.state.estados.length > 0) {
      var lst = this.state.estados.filter((e) =>
        e.estado.includes(valor.toUpperCase())
      );
      return lst.map((l, index) => {
        return (
          <ListGroupItem key={index} idst={l.idEstado}>
            {l.estado}
          </ListGroupItem>
        );
      });
    }
  }

  goEstado(e) {
    var elm = e.target,
      ide = elm.getAttribute("idst"),
      inpE = document.getElementById("inpEstado"),
      dv = document.getElementById("match_list");

    inpE.setAttribute("idestado", ide);
    inpE.value = elm.innerText;
    ReactDom.unmountComponentAtNode(dv);
  }

  onChangeFunc(optionSelected) {
    this.setState({
      estado: { id: optionSelected.value, Name: optionSelected.label },
    });
  }

  toggleSearchable = () =>
    this.setState((state) => ({ isSearchable: !state.isSearchable }));

  render() {
    const selectStyles = {
      control: (base) => ({
        ...base,
        height: 45,
        border: "none",
        borderBottom: "#878787 2px solid",
      }),
      valueContainer: (base) => ({
        ...base,
        height: 45,
      }),
      container: (base) => ({
        ...base,
        height: 45,
      }),
      input: (base) => ({
        ...base,
        height: 45,
      }),
      singleValue: (base) => ({
        ...base,
        top: 27,
      }),
    };

    const { isSearchable } = this.state;

    return (
      <Container>
        <Form
          className="dv_Busqueda size-container"
        >
          <FormGroup className="dv_lbl_top">
            <label>Encuentra las mejores Vacantes</label>
          </FormGroup>
          <MainContainer>
            <InputsContainer form>

              <div>
                <div>
                  <label>Puesto</label>
                  <br />
                  <input type="text" className="frm form-control" id="inpPuesto" />
                </div>
              </div>
              <div >
                <div>
                  <label>Estado</label>
                  <br />
                  <Select
                    className="basic-single"
                    classNamePrefix="select"
                    placeholder="Selecciona"
                    isSearchable={isSearchable}
                    styles={selectStyles}
                    options={this.state.options}
                    onChange={this.onChangeFunc}
                  />
                  {/* <input type='text' className='frm form-control' id='inpEstado' autoComplete="off" onChange={(e) => this.buscaEstado(e)}/> */}
                  <div id="match_list" />
                </div>
              </div>

            </InputsContainer>
            <ButtonContainer form>
              <Col xs={1} sm={4} md={2} lg={3}></Col>
              <Col xs={10} sm={4} md={8} lg={6}>
                <Button
                  outline
                  color="info"
                  style={{ whiteSpace: "nowrap" }}
                  className="btn_Cons_Ofrts"
                  id="btn_consultar"
                  onClick={(e) => this.goOfertas(e)}
                >
                  BUSCAR OFERTAS
                </Button>
              </Col>
              <Col xs={1} sm={4} md={2} lg={3}></Col>
            </ButtonContainer>
          </MainContainer>
        </Form>
      </Container>
    );
  }
}
